<template>
  <section class="encardGame">
    <!--<img src="../assets/background/degradeBackground.png" alt="encardBg" id="encardBg" class="encardBg">-->
    <div class="smartphone-content">
      <div class="smartphone-template">
        <div class="smartphone-video">
          <iframe
            id="ytplayer"
            type="text/html"
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/l09tkLG2qTc"
            frameborder="0"
          />
          <!--<img src="../assets/robbery_bear_preview.png" alt="preview" class="preview_robbery_bear">-->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "EncardGameRobberyBear",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.encardGame {
  position: relative;
  img {
    position: absolute;
  }
  .smartphone-content {
    position: relative;
    .smartphone-template {
      background: url('../assets/smartphonePaysage.png');
      background-position: center;
      background-repeat: no-repeat;
      background-attachment: scroll;
      background-size: contain;
      margin: 0 auto;
      .smartphone-video {
        overflow: hidden;
        height: 100%;
        padding: 11%;
        @media (min-width: 768px) {
          padding: 25px 14px;
          margin: 0px 49px;
        }
        @media (min-width: 992px) {
          padding: 23px 0px;
          margin: 0px 41px;
        }
        @media (min-width: 1200px) {
          padding: 23px 0px;
          margin: 0px 49px;
        }
        iframe{
          @media (min-width: 768px) {
            height: 314px;
            width: 559px;
          }
          @media (min-width: 992px) {
            height: 203px;
            width: 364px;
          }
          @media (min-width: 1200px) {
            height: 246px;
            width: 437px;
          }
        }
      }
    }
  }
  .preview_robbery_bear{
    width: 481px;
    height: 277px;
  }
}
</style>
